<template>
  <div class="Blk3">

  <v-card>
  <v-card-title class="text-h5 grey lighten-5">
    <v-breadcrumbs :items="item">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item :href="goToRoute(item.href)" :disabled="item.disabled">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </v-card-title>
  </v-card>

    <v-snackbar :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
      <v-icon class="snackIcon">{{ snackbar.icon }}</v-icon>

      {{ snackbar.message }}
    </v-snackbar>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("modultangkapandatahes") }}
      </v-card-title>
      <v-container>
        <v-form ref="formblok3">
          <span class="blink_text" style="color:red;font-weight:bold;font-size: medium;"> PERINGATAN!</span><br>
          <span style="color:red;font-weight:bold;font-size: small;"> Medan <strong> TARIKH </strong> wajib diisi dan disemak</span>
          <v-row>
            <v-col cols="12" sm="6"><br>
              <v-text-field v-bind:label="$t('hid')" outlined dense v-model="blok3hid" :disabled="true"></v-text-field>
            </v-col>
            <v-col cols="12" sm="2"><br>
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }"><br>
                  <v-text-field v-model="tahunbulanhari" v-bind:label="$t('pilihtarikh')" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
                </template>
                <v-date-picker v-model="tahunbulanhari" class="mt-4" :min="mindate" :max="maxday"
                  @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2"><br>
              <v-text-field v-bind:label="$t('w')" v-model="blok3mingguan" outlined dense
                :disabled="true"></v-text-field>
            </v-col>
            <v-col cols="12" sm="2"><br>
              <v-text-field v-bind:label="$t('ps')" v-model="blok3pusingan" outlined dense
                :disabled="true"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field v-bind:label="$t('jumlahharian(rm)')" outlined dense :disabled="true"
                v-model="jumlahharian"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-bind:label="$t('jumlahedagang(rm)')" outlined dense :disabled="true"
                v-model="jumlahedagang"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-bind:label="$t('jumlahkeseluruhan(rm)')" outlined dense :disabled="true"
                v-model="jumlahkeseluruhan"></v-text-field>
            </v-col>
            <v-col class="text-right" v-show="this.paparbtn">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="light-blue white--text" @click="btnmodaltambahblok3" v-bind="attrs" v-on="on">
                    <span class="material-icons">add</span>{{ $t("tambah") }}
                  </v-btn>
                </template>
                <span>Tambah Perbelanjaan</span>
              </v-tooltip>

              &nbsp;

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="green white white--text" @click="cariblok3" v-bind="attrs" v-on="on">
                    <span class="material-icons">search</span>{{ $t("cari") }}
                  </v-btn>
                </template>
                <span>Carian Perbelanjaan</span>
              </v-tooltip>
            </v-col>
          </v-row>
          &nbsp;
        </v-form>

        <!-- DATATABLE  -->
        <v-card-title>
          Senarai Perbelanjaan
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="papardatablk3" :search="search" :items-per-page="10"
          class="elevation-1" @click:row="btnmodalkemaskiniblok3">

          <template v-slot:item.Bil="{ item, index }">
            {{ index + 1 }}
          </template>
          <!-- <template v-slot:[`item.SebenarAnggaran`]="{ item }">
              {{ paparsebenaranggaran(item.SebenarAnggaran) }}
            </template>
            <template v-slot:[`item.PuncaPembelian`]="{ item }">
              {{ paparpuncapembelian(item.PuncaPembelian) }}
            </template>
            <template v-slot:[`item.MediumBayaran`]="{ item }">
              {{ paparmediumbayaran(item.MediumBayaran) }}
            </template>
            <template v-slot:[`item.eDagang`]="{ item }">
              {{ papareDagang(item.eDagang) }}
            </template> -->
        </v-data-table>

        <v-dialog v-model="modaltambahblok3" persistent max-width="700px">
          <v-form ref="formtambahblk3" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                <span class="text-h5">{{ $t("tambahblok3") }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <!-- <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-bind:label="$t('koditem')"
                        v-model="tambahkoditem"
                        outlined
                        dense
                        v-on:keyup="papardatakoditem('tambah')"
                        :rules="koditemRules"
                      ></v-text-field>
                    </v-col>
                  </v-row> -->

                  <v-row>
                    <v-col cols="12" sm="8" v-show="paparlookupketeranganitem">
                      <v-autocomplete outlined dense v-bind:label="$t('keteranganitem')" :items="paparketeranganitem"
                        :item-text="
                        (item) => item.KodItem + ' - ' + item.Keterangan" item-value="KodItem"
                        v-on:change="isidatakoditem('tambah')" v-model="tambahketerangankoditem"
                        :rules="keteranganitemRules"></v-autocomplete>
                      <v-text-field v-model="tambahketerangan" v-show="false"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4" v-show="paparinputblok3">
                      <v-text-field v-bind:label="$t('jenisbarang')" outlined dense v-model="tambahjenisbarang"
                        :rules="jenisbarangRules" :disabled="true"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-show="paparinputblok3">
                    <v-col cols="12" sm="6">
                      <v-text-field min="0" maxlength="7" v-bind:label="$t('rm')" outlined dense v-model="tambahRM"
                        v-on:keyup="tukarkecurrentcy" :error-messages="msgtambahRM" required
                        @keypress="isNumber($event)"></v-text-field>


                    </v-col>
                    <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>(Cth: Amaun (termasuk SST, LVGT, HVGT & dll)</span>
          </v-tooltip>

                    <v-col cols="12" sm="6">
                      <v-text-field min="0" maxlength="6" v-bind:label="$t('kuantiti')" outlined dense v-model="tambahkuantiti"
                      :rules="kuantitiRules" required 
                        @keypress="isNumber($event)"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field v-bind:label="$t('unit')" v-model="tambahunit" outlined dense :rules="unitRules"
                        :disabled="true"></v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" sm="6">
                      <v-select
                        outlined
                        dense
                        :items="tambahlookuphargasebenar"
                        v-bind:label="$t('hargasebenar')"
                        v-model="tambahhargasebenar"
                        item-text="desc"
                        item-value="id"
                        :rules="hargasebenarRules"
                      ></v-select>
                    </v-col> -->

                    <v-col cols="12" sm="6">
                      <v-autocomplete outlined dense min="0" maxlength="1" v-bind:label="$t('hargasebenar')"
                        :items="tambahlookuphargasebenar" item-value="id"
                        :item-text="(item) => item.id + ' - ' + item.desc" v-model="tambahhargasebenar"
                        :rules="hargasebenarRules"></v-autocomplete>
                    </v-col>

                    <!-- <v-col cols="12" sm="6">
                      <v-select
                        outlined
                        dense
                        :items="tambahlookuppuncapembelian"
                        v-bind:label="$t('puncapembelian')"
                        v-model="tambahpuncapembelian"
                        item-text="desc"
                        item-value="id"
                        :rules="puncapembelianRules"
                      ></v-select>
                    </v-col> -->

                    <v-col cols="12" sm="6">
                      <v-autocomplete outlined dense min="0" maxlength="2" v-bind:label="$t('puncapembelian')"
                        :items="tambahlookuppuncapembelian" v-model="tambahpuncapembelian" :rules="puncapembelianRules"
                        :item-text="(item) => item.id + ' - ' + item.desc" item-value="id"></v-autocomplete>
                    </v-col>

                    <!-- <v-col cols="12" sm="6">
                      <v-select
                        outlined
                        dense
                        :items="tambahlookupmediumpembayaran"
                        v-bind:label="$t('mediumpembayaran')"
                        v-model="tambahmediumpembayaran"
                        item-text="desc"
                        item-value="id"
                        :rules="mediumpembayaranRules"
                      ></v-select>
                    </v-col> -->

                    <v-col cols="12" sm="6">
                      <v-autocomplete outlined dense min="0" maxlength="2" :items="tambahlookupmediumpembayaran"
                        v-bind:label="$t('mediumpembayaran')" v-model="tambahmediumpembayaran"
                        :rules="mediumpembayaranRules" :item-text="(item) => item.id + ' - ' + item.desc"
                        item-value="id"></v-autocomplete>
                    </v-col>

                    <!-- <v-col cols="12" sm="6">
                      <v-select
                        outlined
                        dense
                        :items="tambahlookupedagang"
                        v-bind:label="$t('edagang')"
                        v-model="tambahedagang"
                        item-text="desc"
                        item-value="id"
                        :rules="edagangRules"
                      ></v-select>
                    </v-col> -->

                    <v-col cols="12" sm="6">
                      <v-autocomplete outlined dense min="0" maxlength="1" :items="tambahlookupedagang"
                        v-bind:label="$t('edagang')" v-model="tambahedagang" :rules="edagangRules"
                        :item-text="(item) => item.id + ' - ' + item.desc" item-value="id"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field outlined dense v-bind:label="$t('catatan')" :rules="catatanRules"
                        v-model="tambahcatatan"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-col cols="12" sm="8" class="text-left">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="grey darken-2 white--text" @click="resetpaparformtambahblok3()" v-bind="attrs" v-on="on">
                        <span class="material-icons">reset_tv</span>
                        {{ $t("reset") }}
                      </v-btn>
                    </template>
                    <span>Reset Perbelanjaan</span>
                  </v-tooltip>
                </v-col>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="light-blue white--text" @click="btntambahkoditem()" v-bind="attrs" v-on="on">
                    <span class="material-icons">save</span>
                      {{ $t("simpan") }}
                    </v-btn>
                  </template>
                  <span>Simpan Perbelanjaan</span>
                </v-tooltip>

                <Overlay v-show="showOverlay" />

                &nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="red accent-4 white--text" @click="modaltambahblok3 = false"  v-bind="attrs" v-on="on">
                      <span class="material-icons">close</span>
                      {{ $t("tutup") }}
                    </v-btn>
                  </template>
                  <span>Tutup Perbelanjaan</span>
                </v-tooltip>

              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="modalkemaskiniblok3" persistent max-width="700px">
          <v-form ref="formkemaskiniblk3" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                <span class="text-h5">{{ $t("kemaskiniblok3") }}</span>
              </v-card-title>
              <v-container>
                <v-text-field v-model="kemaskiniBil" v-show="false"></v-text-field>

                <!-- <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-bind:label="$t('koditem')"
                      v-model="kemaskinikoditem"
                      outlined
                      dense
                      v-on:keyup="papardatakoditem('kemaskini')"
                      :rules="koditemRules"
                    ></v-text-field>
                  </v-col>
                </v-row> -->

                <v-row>
                  <v-col cols="12" sm="6"><br>
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                      offset-y max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }"><br>
                        <v-text-field v-model="tahunbulanhari" v-bind:label="$t('pilihtarikh')"
                          prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
                      </template>

                      <v-date-picker v-model="tahunbulanhari" class="mt-4" :min="mindate" :max="maxday"
                        @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3"><br>
                    <v-text-field v-bind:label="$t('w')" v-model="blok3mingguan" outlined dense
                      :disabled="true"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3"><br>
                    <v-text-field v-bind:label="$t('ps')" v-model="blok3pusingan" outlined dense
                      :disabled="true"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="8" v-show="paparlookupketeranganitem">
                    <v-autocomplete outlined dense v-bind:label="$t('keteranganitem')" :items="paparketeranganitem"
                      :item-text="
                        (item) => item.KodItem + ' - ' + item.Keterangan
                      " item-value="KodItem" v-on:change="isidatakoditem('kemaskini')"
                      v-model="kemaskiniketerangankoditem" :rules="keteranganitemRules"></v-autocomplete>
                    <v-text-field v-model="kemaskiniketerangan" v-show="false"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4" v-show="paparinputblok3">
                    <v-text-field v-bind:label="$t('jenisbarang')" outlined dense v-model="kemaskinijenisbarang"
                      :rules="jenisbarangRules" :disabled="true"></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-show="paparinputblok3">
                  <v-col cols="8" sm="4">
                    <v-text-field min="0" maxlength="7" v-bind:label="$t('rm')" outlined dense v-model="kemaskiniRM"
                      v-on:keyup="tukarkecurrentcy" :error-messages="msgkemaskiniRM" required
                      @keypress="isNumber($event)"></v-text-field>

                      <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>(Cth: Hospital Negeri, Hospital Daerah, Klinik Kesihatan, Klinik Desa atau Klinik Komuniti)</span>
          </v-tooltip>
                  </v-col>

                  <v-col cols="8" sm="4">
                    <v-text-field min="0" maxlength="6" v-bind:label="$t('kuantiti')" v-model="kemaskinikuantiti"
                      outlined dense  :rules="kuantitiRules" required @keypress="isNumber($event)"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field v-bind:label="$t('unit')" v-model="kemaskiniunit" outlined dense :rules="unitRules"
                      :disabled="true"></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" sm="6">
                    <v-select
                      outlined
                      dense
                      :items="tambahlookuphargasebenar"
                      v-bind:label="$t('hargasebenar')"
                      v-model="kemaskinihargasebenar"
                      item-text="desc"
                      item-value="id"
                      :rules="hargasebenarRules"
                    ></v-select>
                  </v-col> -->

                  <v-col cols="12" sm="6">
                    <v-autocomplete outlined dense min="0" maxlength="1" :items="tambahlookuphargasebenar"
                      v-bind:label="$t('hargasebenar')" v-model="kemaskinihargasebenar"
                      :item-text="(item) => item.id + ' - ' + item.desc" item-value="id"
                      :rules="hargasebenarRules"></v-autocomplete>
                  </v-col>

                  <!-- <v-col cols="12" sm="6">
                    <v-select
                      outlined
                      dense
                      :items="tambahlookuppuncapembelian"
                      v-bind:label="$t('puncapembelian')"
                      v-model="kemaskinipuncapembelian"
                      item-text="desc"
                      item-value="id"
                      :rules="puncapembelianRules"
                    ></v-select>
                  </v-col> -->

                  <v-col cols="12" sm="6">
                    <v-autocomplete outlined dense min="0" maxlength="2" :items="tambahlookuppuncapembelian"
                      v-bind:label="$t('puncapembelian')" :item-text="(item) => item.id + ' - ' + item.desc"
                      item-value="id" v-model="kemaskinipuncapembelian" :rules="puncapembelianRules"></v-autocomplete>
                  </v-col>

                  <!-- <v-col cols="12" sm="6">
                    <v-select
                      outlined
                      dense
                      :items="tambahlookupmediumpembayaran"
                      v-bind:label="$t('mediumpembayaran')"
                      v-model="kemaskinimediumpembayaran"
                      item-text="desc"
                      item-value="id"
                      :rules="mediumpembayaranRules"
                    ></v-select>
                  </v-col> -->

                  <v-col cols="12" sm="6">
                    <v-autocomplete outlined dense min="0" maxlength="2" :items="tambahlookupmediumpembayaran"
                      v-bind:label="$t('mediumpembayaran')" :item-text="(item) => item.id + ' - ' + item.desc"
                      item-value="id" v-model="kemaskinimediumpembayaran"
                      :rules="mediumpembayaranRules"></v-autocomplete>
                  </v-col>

                  <!-- <v-col cols="12" sm="6">
                    <v-select
                      outlined
                      dense
                      :items="tambahlookupedagang"
                      v-bind:label="$t('edagang')"
                      v-model="kemaskiniedagang"
                      item-text="desc"
                      item-value="id"
                      :rules="edagangRules"
                    ></v-select>
                  </v-col> -->

                  <v-col cols="12" sm="6">
                    <v-autocomplete outlined dense min="0" maxlength="2" :items="tambahlookupedagang"
                      v-bind:label="$t('edagang')" :item-text="(item) => item.id + ' - ' + item.desc" item-value="id"
                      v-model="kemaskiniedagang" :rules="edagangRules"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field outlined dense v-bind:label="$t('catatan')" :rules="catatanRules"
                      v-model="kemaskinicatatan"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions>
                <v-spacer>
                </v-spacer>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="light-blue white--text" @click="btnkemaskinikoditem()" v-bind="attrs" v-on="on">
                    <span class="material-icons">border_color</span>
                    {{ $t("kemaskini") }}
                  </v-btn>
                </template>
                <span>Kemaskini Perbelanjaan</span>
              </v-tooltip>

              &nbsp;
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="purple darken-2 white--text" @click="padam(kemaskiniBil)" v-bind="attrs" v-on="on">
                    <span class="material-icons">delete</span>
                    {{ $t("padam") }}
                  </v-btn>
                </template>
                <span>Padam Perbelanjaan</span>
              </v-tooltip>
             
              &nbsp;
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="red accent-4 white--text" @click="modalkemaskiniblok3 = false" v-bind="attrs" v-on="on">
                    <span class="material-icons">close</span>
                    {{ $t("tutup") }}
                  </v-btn>
                </template>
                <span>Tutup Perbelanjaan</span>
              </v-tooltip>

                <!-- Error Dialog -->
                <v-dialog v-model="errorDialog" width="500" height="200">
                  <v-card>
                    <v-alert dense outlined color="#C51162" type="error">
                      <strong>{{ errMessage }}</strong>
                    </v-alert>
                  </v-card>
                </v-dialog>

                <!-- Success Dialog -->
                <v-dialog v-model="successDialog" width="500" height="200">
                  <v-card color="success">
                    <v-alert dense outlined color="#C51162" type="success">
                      <strong>{{ successMessage }}</strong>
                    </v-alert>
                  </v-card>
                </v-dialog>

              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import axios from "../../plugins/axios";
import i18n from "@/i18n";

import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import Overlay from '../../components/Overlay'

//////////////////////////end import services//////////////
export default {
  Name: "Blk3",
  components: {
    Overlay
  },
  setup() { },
  async beforeMount() {
    //this.getUnits('ayam')
    // var dataHID = localStorageData.getHIDdata()

    // this.blok3hid = dataHID.HID;
    // this.BNO = dataHID.BNO;
    // this.blok3pusingan = dataHID.P;
    // this.S = dataHID.S;
    // this.NG = dataHID.NG;
    // this.DP = dataHID.DP;
    // this.DB =  dataHID.DB;
    // this.BP = dataHID.BP;
    // this.ST = dataHID.ST;
    // this.NOTK = dataHID.NOTK;
    // this.NOIR = dataHID.NOIR;
    // this.Bulan = dataHID.BULAN;
    // this.Tahun = dataHID.TAHUN;

    this.paparketeranganitem = await lookup.getlookupBlok3();
  },
  computed: {
    tambahlookuphargasebenar() {
      return lookup.getHargasebenaranggaran();
    },
    tambahlookuppuncapembelian() {
      return lookup.getPuncapembelian();
    },
    tambahlookupmediumpembayaran() {
      return lookup.getMediumpembayaran();
    },
    tambahlookupedagang() {
      return lookup.getEdagang();
    },
    //    paparketeranganitem() {
    //   return lookup.getlookupBlok3();
    // }
  },
  data: () => ({
    papardatablk3: [],
    headers: [
      {
        text: i18n.t("Bil."),
        align: "start",
        sortable: false,
        value: "Bil",
      },
      { text: i18n.t("koditem"), value: "KodItem" },
      { text: i18n.t("keteranganitem"), value: "Keterangan" },
      { text: i18n.t("jenisbarang"), value: "JenisBarang" },
      { text: i18n.t("rm"), value: "RMNEG" },
      { text: i18n.t("kuantiti"), value: "Kuantiti" },
      { text: i18n.t("unit"), value: "Unit" },
      { text: i18n.t("hargasebenar"), value: "SebenarAnggaran" },
      { text: i18n.t("puncapembelian"), value: "PuncaPembelian" },
      { text: i18n.t("mediumpembayaran"), value: "MediumBayaran" },
      { text: i18n.t("edagang"), value: "eDagang" },
      { text: i18n.t("catatan"), value: "Catatan" },
    ],
    showOverlay: false,
    search: "",
    successDialog: false,
    errorDialog: false,
    jumlahharian: "0.00",
    jumlahedagang: "0.00",
    jumlahkeseluruhan: "0.00",
    snackbar: "",
    tahunbulanhari: "",
    mindate: "",
    maxday: "",
    menu1: false,
    menu2: false,
    tambahkuantiti: "",
    // msgtambahkuantiti: [],
    // msgkemaskinikuantiti: [],
    tambahunit: "",
    tambahhargasebenar: "",
    tambahpuncapembelian: "",
    tambahRM: "",
    msgtambahRM: [],
    msgkemaskiniRM: [],
    tambahRM_HQ: "",
    valid: true,
    tambahjenisbarang: "",
    tambahkoditem: "",
    tambahketerangankoditem: "",
    tambahketerangan: "",
    tambahmediumpembayaran: "",
    tambahedagang: "",
    tambahcatatan: "",
    paparketeranganitem: [],
    paparinputblok3: false,
    paparlookupketeranganitem: true,
    modaltambahblok3: false,
    modalkemaskiniblok3: false,
    paparbtn: false,
    blok3hid: "",
    blok3tahun: "",
    blok3bulan: "",
    blok3pusingan: "",
    blok3mingguan: "",
    kemaskinikoditem: "",
    kemaskiniketerangankoditem: "",
    kemaskiniketerangan: "",
    kemaskinijenisbarang: "",
    kemaskiniRM: "",
    kemaskiniRM_HQ: "",
    kemaskinikuantiti: "",
    kemaskiniunit: "",
    // kemaskininamaunit: "",
    kemaskinihargasebenar: "",
    kemaskinipuncapembelian: "",
    kemaskinimediumpembayaran: "",
    kemaskiniedagang: "",
    kemaskinicatatan: "",
    kemaskiniBil: "",
    Ind: "",
    errMessage: '',
    successMessage: '',
    alertText: "",
    alert: false,
    alertType: "error",
    hari: [],
    bulan: [],
    rules: {},
    disabledpuncapembelian:false,

    koditemRules: [
      (v) => !!v || `${i18n.t("koditem")} ${i18n.t("adalahdiperlukan")}`,
    ],
    keteranganitemRules: [
      (v) => !!v || `${i18n.t("keteranganitem")} ${i18n.t("adalahdiperlukan")}`,
    ],
    jenisbarangRules: [
      (v) => !!v || `${i18n.t("jenisbarang")} ${i18n.t("adalahdiperlukan")}`,
    ],
    rmRules: [
      (v) => !!v || `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`,
    //   (v) => (v != '0') || `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`

    ],
    kuantitiRules: [
      (v) => !!v || `${i18n.t("kuantiti")} ${i18n.t("adalahdiperlukan")}`,
      (v) => (v != '0') || `${i18n.t("kuantiti")} ${i18n.t("perludiisinilaiyangbetul")}`,
      
    ],
    unitRules: [
      (v) => !!v || `${i18n.t("unit")} ${i18n.t("adalahdiperlukan")}`,
    ],
    hargasebenarRules: [
      (v) => !!v || `${i18n.t("hargasebenar")} ${i18n.t("adalahdiperlukan")}`,
      v => (v && v.length == 1) || '1 digit sahaja dibenarkan',
    ],
    puncapembelianRules: [
      (v) => !!v || `${i18n.t("puncapembelian")} ${i18n.t("adalahdiperlukan")}`,
    ],
    mediumpembayaranRules: [
      (v) => !!v || `${i18n.t("mediumpembayaran")} ${i18n.t("adalahdiperlukan")}`,
    ],
    edagangRules: [
      (v) => !!v || `${i18n.t("edagang")} ${i18n.t("adalahdiperlukan")}`,
    ],
    catatanRules: [
      (v) => !!v || `${i18n.t("catatan")} ${i18n.t("adalahdiperlukan")}`,
    ],
    ///////////link untuk ke page/////////////////////
    item: [
      {
        text: "Paparan Utama",
        disabled: false,
        href: "paparanutama",
      },
      {
        text: "BLOK3 (PreCode)",
        disabled: false,
        href: "BLK3PreCode",
      },
      {
        text: "BLOK 3",
        disabled: true,
        href: "blk3",
      },
      {
        text: "BLOK 4a",
        disabled: false,
        href: "Blok4a",
      },
      {
        text: "BLOK 4b",
        disabled: false,
        href: "Blok4b",
      },
      {
        text: "BLOK 4c",
        disabled: false,
        href: "Blok4c",
      },
      {
        text: "BLOK 7",
        disabled: false,
        href: "blk7",
      },
      {
        text: "BLOK 7 (Imbangan)",
        disabled: false,
        href: "Blok7Imbangan",
      },
      {
        text: "Pengesahan (Imbangan)",
        disabled: false,
        href: "PengesahanImbangan",
      },
    ],
  }),
  mounted() {
    this.paparanpermulaan();
    //this.cariblok3();
    this.tambahcatatan = "-";
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}/${this.$route.params.hid}`;
    },
    isNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    async paparmodaltambah() {
      this.modaltambahblok3 = true
      this.modalkemaskiniblok3 = false
    },

    async hapusblk3() {
      // alert(this.kemaskiniBil)
      if (confirm(`${i18n.t("hapus")}`)) {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/blk/hapusdatablk3`, {
            blk3bil: this.kemaskiniBil,
          })
          .then((res) => {
            console.log(res);
            if (res.data.result === 1) {
              this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
              this.cariblok3.push;//rara ubah 430 pm 1/11/2023
            } else {
              this.snackbar = {
                message: i18n.t("cubalagi"),
                timeout: 2000,
                color: "red darken-4",
                show: true,
              };
            }
          });
      }
    },
    async btnkemaskinikoditem() {
      if (this.$refs.formkemaskiniblk3.validate()) {

        const datakemaskini = {
          kemaskiniBil: this.kemaskiniBil,
          tahunbulanhari: this.tahunbulanhari,
          blok3mingguan: this.blok3mingguan,
          blok3pusingan: this.blok3pusingan,
          kemaskiniketerangankoditem: this.kemaskiniketerangankoditem,
          kemaskiniketerangan: this.kemaskiniketerangan,
          kemaskinijenisbarang: this.kemaskinijenisbarang,
          kemaskiniRM: this.RMNEG,
          kemaskiniRM_HQ: this.RMHQ,
          kemaskinikuantiti: this.kemaskinikuantiti,
          kemaskiniunit: this.kemaskiniunit,
          // kemaskininamaunit: this.kemaskininamaunit,
          kemaskinihargasebenar: this.kemaskinihargasebenar,
          kemaskinipuncapembelian: this.kemaskinipuncapembelian,
          kemaskinimediumpembayaran: this.kemaskinimediumpembayaran,
          kemaskiniedagang: this.kemaskiniedagang,
          kemaskinicatatan: this.kemaskinicatatan,
          Ind: this.Ind,
        };
      
        let vali = 0
        if (this.kemaskiniRM === '') {
          vali++
          this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
        } else {
          this.msgkemaskiniRM = []
        }

        // if (this.kemaskiniketerangankoditem !== "00000000") {
        //   if (parseFloat(this.kemaskiniRM) === 0) {
        //     vali++
        //     this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`
        //   } else {
        //     this.msgkemaskiniRM = []
        //   }
        // }

        if (this.kemaskiniketerangankoditem !== "00000000" && parseFloat(this.kemaskiniRM) === 0 || 
            this.kemaskiniketerangankoditem === "00000000" && parseFloat(this.kemaskiniRM) !== 0) {
            vali++;
          this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`;
        } else {
          this.msgkemaskiniRM = [];
        }

        if (vali === 0) {
        // console.log(datakemaskini);
        await axios
          .post(`${process.env.VUE_APP_API_URL}/blk/kemaskiniblk3`, datakemaskini)
          .then((result) => {
            if (result.data.result === 1) {
              this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
                icon: "check_circle",
              };
              this.cariblok3.push;//rara ubah 430 pm 1/11/2023;
              this.modalkemaskiniblok3 = false;
            } else {
              this.snackbar = {
                message: i18n.t("cubalagi"),
                timeout: 2000,
                color: "red darken-4",
                show: true,
                icon: "error_outline",
              };
            }
          });
        } else {
        this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
        }
       }
    },

    async padam(kemaskiniBil) {
      console.log(this.kemaskiniBil);
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/blk/deleteblk3`,
          {
            kemaskiniBil: kemaskiniBil,
          }
        );
        this.successDialog = true;
        setTimeout(() => (this.successDialog = false), 2000);
        this.successMessage = "Data Berjaya Dipadam!";
        this.noairClick = false;
        this.modalkemaskiniblok3 = false;
        this.cariblok3.push;//rara ubah 430 pm 1/11/2023;
      } catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Padam : " + error;
      }
    },
    async btnmodalkemaskiniblok3(row) {
      // console.log('row')
      // console.log(row)
      // console.log('this.paparketeranganitem')
      // console.log(this.paparketeranganitem)
      this.modalkemaskiniblok3 = true;
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/blk/paparrowdatablok3`, {
            blk3bil: row.Bil,
          })
          .then((result) => {
            //console.log("jhbjkh"+ JSON.stringify(result.data.data));
            const namaunit = this.paparketeranganitem.filter(el => el.KodItem === result.data.data.KodItem)
            // console.log('namaunit[0]')
            // console.log(namaunit[0].namaUnit)
            this.kemaskiniBil = result.data.data.Bil;
            // this.tahunbulanhari = result.data.data.Tarikh;
            // this.blok3mingguan = result.data.data.Minggu;
            this.kemaskinikoditem = result.data.data.KodItem;
            this.kemaskiniketerangankoditem = result.data.data.KodItem;
            this.kemaskiniketerangan = result.data.data.Keterangan;
            this.kemaskinijenisbarang = result.data.data.JenisBarang;
            this.kemaskiniunit = `${result.data.data.Unit} - ${namaunit[0].namaUnit}`;
            // this.kemaskininamaunit = result.data.data.namaUnit;
            this.kemaskiniRM = result.data.data.RMNEG;
            this.kemaskinikuantiti = result.data.data.Kuantiti;
            this.kemaskinihargasebenar = result.data.data.SebenarAnggaran;
            this.kemaskinipuncapembelian = result.data.data.PuncaPembelian;
            this.kemaskinimediumpembayaran = result.data.data.MediumBayaran;
            this.kemaskiniedagang = result.data.data.eDagang;
            this.kemaskinicatatan = result.data.data.Catatan;
            this.Ind = result.data.data.Ind;
            //this.papardatakoditem("kemaskini");
            this.paparinputblok3 = true;
          });
      } catch (err) {
        console.log(err);
      }
    },
    papareDagang(id) {
      let eDagang = "";
      lookup.getEdagang().forEach(async function (element) {
        if (id === element.id) {
          eDagang = element.desc;
        }
      });
      return eDagang;
    },
    paparpuncapembelian(id) {
      let puncapembelian = "";
      lookup.getPuncapembelian().forEach(async function (element) {
        if (id === element.id) {
          puncapembelian = element.desc;
        }
      });
      return puncapembelian;
    },
    paparsebenaranggaran(id) {
      let sebenaranggaran = "";
      lookup.getHargasebenaranggaran().forEach(async function (element) {
        if (id === element.id) {
          sebenaranggaran = element.desc;
        }
      });
      return sebenaranggaran;
    },

    paparmediumbayaran(id) {
      let mediumpembayaran = "";
      lookup.getMediumpembayaran().forEach(async function (element) {
        if (id === element.id) {
          mediumpembayaran = element.desc;
        }
      });
      return mediumpembayaran;
    },

    async btntambahkoditem() {
      //console.log(this.RMNEG)
      if (this.$refs.formtambahblk3.validate()) {
       
        const tambahblok3 = {
          blok3hid: this.blok3hid,
          tahunbulanhari: this.tahunbulanhari,
          blok3mingguan: this.blok3mingguan,
          blok3pusingan: this.blok3pusingan,
          tambahketerangankoditem: this.tambahketerangankoditem,
          tambahketerangan: this.tambahketerangan,
          tambahjenisbarang: this.tambahjenisbarang,
          // tambahRM: this.tambahRM,
          tambahRM_HQ: this.RMHQ,
          tambahRM: this.RMNEG,
          tambahkuantiti: this.tambahkuantiti,
          tambahunit: this.tambahunit,
          tambahhargasebenar: this.tambahhargasebenar,
          tambahpuncapembelian: this.tambahpuncapembelian,
          tambahmediumpembayaran: this.tambahmediumpembayaran,
          tambahedagang: this.tambahedagang,
          tambahcatatan: this.tambahcatatan,
          Ind: this.Ind
        };
        this.showOverlay = true;
      
        let vali = 0
        if (this.tambahRM === '') {
          vali++
          this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
        } else {
          this.msgtambahRM = []
        }

        // if (this.tambahketerangankoditem !== "00000000") {
        //   if (parseFloat(this.tambahRM) === 0) {
        //     vali++
        //     this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`
        //   } else {7
        //     this.msgtambahRM = []
        //   }
        // }
        if ((this.tambahketerangankoditem !== "00000000" && parseFloat(this.tambahRM) === 0) 
              || (this.tambahketerangankoditem == "00000000" && parseFloat(this.tambahRM) !== 0)) {
              vali++;
              this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`;
        } else {
          this.msgtambahRM = [];
        }

        
        if (vali === 0) {
          await axios
          .post(
            `${process.env.VUE_APP_API_URL}/blk/masukdatablok3`,
            tambahblok3
          )
          .then((res) => {
            this.showOverlay = false;
            console.log(res.data.status);
            if (res.data.status) {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                color: "green white white--text",
                text: i18n.t("berjaya"),
                timeout: 2000,
              });
              this.resetpaparformtambahblok3();
              this.cariblok3.push;//rara ubah 430 pm 1/11/2023;
            } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: i18n.t("cubalagi"),
                timeout: 2000,
              });
            }
          });
        } else {
          this.showOverlay = false;
        }
      } else {
        this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
      }
    },

    async tukarkecurrentcy() {
      // console.log(this.tambahRM.length);
      // if (this.tambahRM.length >= 4) {
      //   const numberFormatter = new Intl.NumberFormat("de-DE", {
      //     maximumSignificantDigits: 3,
      //   });
      //   console.log(numberFormatter.format(this.tambahRM));
      //   this.tambahRM = numberFormatter.format(this.tambahRM);
      // }
    },
    async isidatakoditem(mode) {
      try {
        let koditem = "";
        let jenisbarang = "";
        let keterangan = "";
        let unit = "";
        let namaUnit = "";
        let Ind = "";
        if (mode === "tambah") {
          koditem = this.tambahketerangankoditem;
          //console.log(koditem)
        } else if (mode === "kemaskini") {
          koditem = this.kemaskiniketerangankoditem;
        }
        this.paparketeranganitem.forEach(async function (element) {
          // console.log(element);
          if (koditem === element.KodItem) {
            jenisbarang = element.JenisBarang;
            keterangan = element.Keterangan;
            unit = element.Unit + " - " + element.namaUnit;
            Ind = element.Ind;
            // console.log(unit);
            //console.log(this.paparketeranganitem)
          }
        });
        if (mode === "tambah") {
          this.tambahketerangan = keterangan;
          this.tambahkoditem = koditem;
          this.tambahjenisbarang = jenisbarang;
          this.tambahunit = unit + namaUnit;
          this.Ind = Ind;
          this.paparinputblok3 = true;
          this.tambahcatatan = "-";
        } else if (mode === "kemaskini") {
          this.kemaskiniketerangan = keterangan;
          this.kemaskinijenisbarang = jenisbarang;
          this.paparinputblok3 = true;
          this.kemaskinikoditem = koditem;
          this.kemaskinijenisbarang = jenisbarang;
          this.kemaskiniunit = unit + namaUnit;
          //this.Ind = this.getIND(koditem);
          this.Ind = Ind;

        }
      } catch (err) {
        alert(err);
      }
    },

    async paparanpermulaan() {
      try {
        if (typeof this.$route.params.hid !== "undefined") {
          await axios
            .get(
              `${process.env.VUE_APP_API_URL}/auth/decode?de=${this.$route.params.hid}`
            )
            .then((result) => {
              this.blok3hid = result.data.decode;
              const jr2 = {
                hidjr2: this.blok3hid,
              };
              axios
                .post(`${process.env.VUE_APP_API_URL}/JR/papardatajr2`, jr2)
                .then((res) => {
                  this.blok3tahun = res.data.data.TAHUN;
                  this.blok3bulan = res.data.data.BULAN;
                  this.blok3pusingan = res.data.data.P;
                  //console.log(`${this.blok3tahun}-${this.blok3bulan}-01`)
                  this.mindate = `${this.blok3tahun}-${this.blok3bulan}-01`;
                  this.maxday = `${this.blok3tahun}-${this.blok3bulan}-31`;
                  this.cariblok3.push;//rara ubah 430 pm 1/11/2023;
                  //this.cariblok3();
                  
                });
            });
        } else {
          this.$router.push(`/${i18n.locale}/heshid`, () => { });
        }
      } catch (err) {
        console.log(err);
        if (err.response.data.msg === "errordecode") {
          this.$router.push(`/${i18n.locale}/heshid`, () => { });
        }
      }
    },
    async cariblok3() {
      try {
        const caridatablok3 = {
          blok3hid: this.blok3hid,
          tahunbulanhari: this.tahunbulanhari,
        };
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/blk/caridatablok3`,
            caridatablok3
          )
          .then((result) => {
            // console.log(result.data.data);
            this.papardatablk3 = result.data.data;
            let jumharian = 0;
            let jumedagang = 0;
            let jumkeseluruhan = 0;
            result.data.data.forEach(async function (element) {
              if (element.eDagang === "1") {
                jumedagang += parseFloat(element.RMNEG);
                jumkeseluruhan += parseFloat(element.RMNEG);
              } else {
                jumharian += parseFloat(element.RMNEG);
                jumkeseluruhan += parseFloat(element.RMNEG);
              }
            });
            this.jumlahedagang = jumedagang.toFixed(2);
            this.jumlahharian = jumharian.toFixed(2);
            this.jumlahkeseluruhan = jumkeseluruhan.toFixed(2);
          });
      } catch (err) {
        alert(err);
      }
    },
    async mingguanberdasarknhari(hari) {
      if (hari >= 1 && hari <= 7) {
        this.blok3mingguan = "1";
      }
      if (hari >= 4 && hari <= 14) {
        this.blok3mingguan = "2";
      }
      if (hari >= 15 && hari <= 21) {
        this.blok3mingguan = "3";
      }
      if (hari >= 22 && hari <= 28) {
        this.blok3mingguan = "4";
      }
      if (hari >= 29 && hari <= 31) {
        this.blok3mingguan = "5";
      }
    },
    async btnmodaltambahblok3() {
      this.modaltambahblok3 = true;
      this.resetpaparformtambahblok3()
    },
    async resetpaparformtambahblok3() {
      // this.paparlookupketeranganitem = false;
      this.paparinputblok3 = false;
      this.$refs.formtambahblk3.resetValidation();
      this.$refs.formtambahblk3.reset();
      //this.paparketeranganitem = await lookup.getlookupBlok3();
    },
    async papardatakoditem(mode) {
      try {
        let papardatakoditem = "";
        if (mode === "tambah") {
          papardatakoditem = this.tambahkoditem;
        } else if (mode === "kemaskini") {
          papardatakoditem = this.kemaskinikoditem;
        }
        if (papardatakoditem.length >= 4) {
          //console.log(papardatakoditem);
          const datakoditem = {
            koditem: papardatakoditem,
          };
          await axios
            .post(
              `${process.env.VUE_APP_API_URL}/blk/paparkoditem`,
              datakoditem
            )
            .then((res) => {
              this.paparketeranganitem = res.data.data;
              //console.log(this.paparketeranganitem);
            });
          this.paparlookupketeranganitem = true;
        } else {
          this.paparlookupketeranganitem = false;
          this.paparketeranganitem = [];
          this.paparlookupketeranganitem = false;
          this.paparinputblok3 = false;
        }
      } catch (err) {
        alert(err);
      }
    },
  },
  watch: {
    tambahRM(val) {
      //console.log('ind:'+this.Ind)
      if (this.Ind == 1) {
        //console.log('val:'+val)
        this.RMNEG = Number(this.tambahRM);
        this.RMHQ = Number(this.tambahRM) / 12;
      } else {
        this.RMHQ = Number(this.tambahRM);
        this.RMNEG = Number(this.tambahRM);
      }
    },

    tambahketerangankoditem(val) {
 
 if (this.tambahketerangankoditem == 0) {
     this.tambahRM = '0' ;
     this.tambahkuantiti ='0';
     this.tambahhargasebenar ='0';
     this.tambahpuncapembelian ='00';
     this.tambahmediumpembayaran ='00';
     this.tambahedagang ='0';
    } else if (this.tambahketerangankoditem != 0) {
     this.tambahRM ='';
     this.tambahkuantiti ='';
     this.tambahhargasebenar ='';
     this.tambahpuncapembelian ='';
     this.tambahmediumpembayaran ='';
     this.tambahedagang =''; 
 }

},

    kemaskiniRM(val) {
      //console.log('val:'+this.kemaskiniRM)
      //console.log('ind:'+this.Ind)
      if (this.Ind == 1) {
        this.RMNEG = Number(this.kemaskiniRM);
        this.RMHQ = Number(this.kemaskiniRM) / 12;
      } else {
        this.RMHQ = Number(this.kemaskiniRM);
        this.RMNEG = Number(this.kemaskiniRM);
      }
      // console.log('RMHQ:'+this.RMHQ )
      // console.log('RMNEG:'+this.RMNEG)
    },

    kemaskiniketerangankoditem(val) {
 
      if (this.kemaskiniketerangankoditem == 0) {
     this.kemaskiniRM ='0';
     this.kemaskinikuantiti ='0';
     this.kemaskinihargasebenar ='0';
     this.kemaskinipuncapembelian ='00';
     this.kemaskinimediumpembayaran ='00';
     this.kemaskiniedagang ='0';
  // } else if (this.kemaskiniketerangankoditem != 0) {
  //    this.kemaskiniRM ='';
  //    this.kemaskinikuantiti ='';
  //    this.kemaskinihargasebenar ='';
  //    this.kemaskinipuncapembelian ='';
  //    this.kemaskinimediumpembayaran ='';
  //    this.kemaskiniedagang ='';  

}
  
},

    tahunbulanhari(val) {
      const [tahun, bulan, hari] = val.split("-");
      tahun;
      bulan;
      this.mingguanberdasarknhari(hari);
      this.paparbtn = true;
    },
  },
};
</script>
<style>
.blink_text {
 animation-name: blinker;
 animation-duration: 1s;
 animation-timing-function: linear;
 animation-iteration-count: infinite;
}

@keyframes blinker {  
 0% { opacity: 1.0; }
 50% { opacity: 0.0; }
 100% { opacity: 1.0; }
}

</style>
